import { render, staticRenderFns } from "./ShowTestsDetailed.vue?vue&type=template&id=1bac1204&scoped=true&"
import script from "./ShowTestsDetailed.vue?vue&type=script&lang=js&"
export * from "./ShowTestsDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac1204",
  null
  
)

export default component.exports